import { CognitoRefreshToken } from "amazon-cognito-identity-js";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { getUserProfileTokenName } from "../components/shared/helpers/helper";
import Pool from "../UserPool";
import { installDevWriteGuard } from "./devWriteGuard";
export const socketURL = `wss://2wj854ju50.execute-api.us-east-1.amazonaws.com/prod/`;
export const baseURL = `https://8xziz8l91m.execute-api.us-east-1.amazonaws.com/`;

export const AUTH_REFRESH_REQUEST = async () => {
  var userName = localStorage.getItem(
    "CognitoIdentityServiceProvider." +
      process.env.REACT_APP_CLIENT_ID +
      ".LastAuthUser",
  );
  var decoded = jwt_decode(
    localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".idToken",
    ),
  );
  const expDate = new Date(0);
  expDate.setUTCSeconds(decoded.exp);
  const nowDate = new Date(Date.now());
  const user = Pool.getCurrentUser();
  if (nowDate > expDate) {
    var refreshToken = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".refreshToken",
    );
    var tokentoRefresh = new CognitoRefreshToken({
      RefreshToken: refreshToken,
    });
    await new Promise((resolve, reject) => {
      user.refreshSession(tokentoRefresh, (err, session) => {
        if (session) {
          localStorage.setItem(
            "CognitoIdentityServiceProvider." +
              process.env.REACT_APP_CLIENT_ID +
              "." +
              userName +
              ".idToken",
            session.idToken.jwtToken,
          );
          localStorage.setItem(
            "CognitoIdentityServiceProvider." +
              process.env.REACT_APP_CLIENT_ID +
              "." +
              userName +
              ".refreshToken",
            session.refreshToken.token,
          );
          localStorage.setItem(
            "CognitoIdentityServiceProvider." +
              process.env.REACT_APP_CLIENT_ID +
              "." +
              userName +
              ".accessToken",
            session.accessToken.jwtToken,
          );
          // console.log("refresh token ran")
          // console.log(session)
          resolve();
        }
        if (err) {
          console.log(err);
          reject();
        }
        // return session.idToken.jwtToken
      });
    });
  }
};

export const getToken = async () => {
  await AUTH_REFRESH_REQUEST();
  try {
    var userName = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        ".LastAuthUser",
    );

    var token = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".idToken",
    );

    return token;

    // CognitoIdentityServiceProvider.2bcmv2vfab5756kh6vfdidpo.first-user.idToken
  } catch (e) {
    console.log(e);
  }
};

axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = false;
// axios.defaults.headers.common['Authorization'] = `${getToken()}`;
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export function refreshToken() {
  const user = Pool.getCurrentUser();
  var userName = localStorage.getItem(
    "CognitoIdentityServiceProvider." +
      process.env.REACT_APP_CLIENT_ID +
      ".LastAuthUser",
  );
  var refreshToken = localStorage.getItem(
    "CognitoIdentityServiceProvider." +
      process.env.REACT_APP_CLIENT_ID +
      "." +
      userName +
      ".refreshToken",
  );
  var tokentoRefresh = new CognitoRefreshToken({ RefreshToken: refreshToken });
  user.refreshSession(tokentoRefresh, (err, session) => {
    localStorage.setItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".idToken",
      session.idToken.jwtToken,
    );
    localStorage.setItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".refreshToken",
      session.refreshToken.token,
    );
    localStorage.setItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".accessToken",
      session.accessToken.jwtToken,
    );
    // return session.idToken.jwtToken
  });
}

// axios.interceptors.request.use(async (config) => {
//   const extendedConfig = {
//     headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
//   }
//   const newConfig = Object.assign({}, config, extendedConfig)
//   return newConfig;
// }, function (error) {
//   return Promise.reject(error);
// });

export const dashboardAxios = axios.create({
  baseURL: "https://8xziz8l91m.execute-api.us-east-1.amazonaws.com/prod/",
  withCredentials: false,
});

export const s3Axios = axios.create({
  baseURL: "https://2btlnnr7i2.execute-api.us-west-1.amazonaws.com/prod/",
  withCredentials: false,
});

export const searchAxios = axios.create({
  baseURL: "https://2btlnnr7i2.execute-api.us-west-1.amazonaws.com/prod/",
  withCredentials: false,
});
export const textAxios = axios.create({
  baseURL: "https://2btlnnr7i2.execute-api.us-west-1.amazonaws.com/",
  withCredentials: false,
});

export const intakeAxios = axios.create({
  baseURL: "https://ajyjb3k9sl.execute-api.us-east-1.amazonaws.com",
  withCredentials: false,
});

export const taskAxios = axios.create({
  baseURL: "https://gffzx0lepg.execute-api.us-west-1.amazonaws.com/",
  withCredentials: false,
});

taskAxios.interceptors.request.use(async (config) => {
  config.headers.authorization = await getToken();
  return config;
});

// Every instance is guarded, or none is: a partially guarded app looks like it
// works and still writes to production. The gate is a literal so the whole block
// is eliminated from production builds.
if (process.env.NODE_ENV !== "production") {
  installDevWriteGuard(axios);
  installDevWriteGuard(dashboardAxios);
  installDevWriteGuard(s3Axios);
  installDevWriteGuard(searchAxios);
  installDevWriteGuard(textAxios);
  installDevWriteGuard(intakeAxios);
  installDevWriteGuard(taskAxios);
}

export const getUserId = () => {
  try {
    var userName = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        ".LastAuthUser",
    );

    var token = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".idToken",
    );
    var decoded = jwt_decode(token);
    return decoded.sub;
  } catch {
    return "";
  }
};

export const isAdmin = () => {
  const userInfo = JSON.parse(localStorage.getItem(getUserProfileTokenName()));

  try {
    if (userInfo["custom:Admin"]) {
      if (userInfo["custom:Admin"] === "true") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch {
    return false;
  }
};

export const Endpoint = {
  submitCase: async (data) =>
    s3Axios.post(`submit_case`, data, {
      headers: {
        "content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getCase: async (id) =>
    dashboardAxios.get("get_case", {
      params: { action: "all", file_no: id, user_id: getUserId() },
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  delveSearch: async (data) =>
    searchAxios.get("delve", {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  fastSearch: async (data) =>
    searchAxios.get("FastPeopleSearchAPI", {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  saveCase: async (data) =>
    searchAxios.post(`save_case`, data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  OccuTraceSaveCase: async (data) =>
    searchAxios.post(`OccuTrace-savecase`, data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),

  uploadFile: async (data) =>
    s3Axios.get("upload_s3", {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  uploadMultiFile: async (data) =>
    s3Axios.post("upload_s3", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  saveSubject: async (data) =>
    s3Axios.post("save_subject", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getFile: async (data) =>
    s3Axios.get("download_s3", {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),

  getFiles: async (data) =>
    s3Axios.get("get_s3_list", {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  deleteFile: async (data) =>
    s3Axios.delete("delete_docs", {
      params: { key: data },
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
      },
    }),
  searchCase: async (data) =>
    textAxios.post("test/search_cases", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  searchCaseNP: async (data) =>
    s3Axios.post("search_cases", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  searchCases: async (data) =>
    dashboardAxios.post("item_cases", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  // field: "client_file_no" | "property_address". Returns { field, matches }.
  checkDuplicate: async (field, value, signal) =>
    dashboardAxios.post(
      "duplicate_check",
      { field, value },
      {
        signal,
        headers: {
          "Content-Type": "application/json",
          authorization: await getToken(),
        },
      },
    ),
  getAllCasesAdmin: async () =>
    s3Axios.get("get_all_cases", {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  createClient: async (data) =>
    s3Axios.post("clients_api", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  // Sets only the fields sent. A `contact` field adds or replaces that one
  // contact and leaves the client's other contacts alone.
  updateClient: async (data) =>
    s3Axios.patch("clients_api", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getClients: async () =>
    s3Axios.get("clients_api", {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getClientsAndUsers: async () =>
    s3Axios.get("get_clients_users", {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  updateProfile: async (data) =>
    s3Axios.post("user_api", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getUsers: async () =>
    s3Axios.get("user_api", {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getSearchResult: async (data) =>
    s3Axios.get("get_search_results", {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  searchService: async (data) =>
    s3Axios.post("services_search", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  upateSearchService: async (data) =>
    s3Axios.post("update_search_results", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getInvoice: async (data) =>
    s3Axios.get("get_invoice", {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getInvoices: async (data) =>
    s3Axios.get(`accounting`, {
      params: data,
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  saveInvoices: async (data) =>
    s3Axios.post("accounting", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  quicksightDashboard: async (data) =>
    s3Axios.post("dashboard_embed", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getInvestigators: async () =>
    s3Axios.get("investigators", {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  createInvestigator: async (data) =>
    s3Axios.post("investigators", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  getFieldResources: async () =>
    s3Axios.get("field-resources", {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  createFieldResource: async (data) =>
    s3Axios.post("field-resources", data, {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
    }),
  deleteFieldResource: async (id) =>
    s3Axios.delete("field-resources", {
      headers: {
        "Content-Type": "application/json",
        authorization: await getToken(),
      },
      params: {
        id: id,
      },
    }),

  // Intake / AI Chat endpoints (HTTP API v2 JWT authorizer requires Bearer prefix)
  listIntakes: async () =>
    intakeAxios.get("/intakes", {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${await getToken()}`,
      },
    }),
  createIntake: async (label = "") =>
    intakeAxios.post(
      "/intakes/new",
      { label },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${await getToken()}`,
        },
      },
    ),
  getIntakeMessages: async (intakeId) =>
    intakeAxios.get(`/intakes/${intakeId}/messages`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${await getToken()}`,
      },
    }),
  sendChatMessage: async (intakeId, message) =>
    intakeAxios.post(
      "/chat",
      { intake_id: intakeId, message },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${await getToken()}`,
        },
      },
    ),
  closeIntake: async (intakeId) =>
    intakeAxios.post(
      `/intakes/${intakeId}/close`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${await getToken()}`,
        },
      },
    ),
  updateIntakeLabel: async (intakeId, label) =>
    intakeAxios.post(
      `/intakes/${intakeId}/edit`,
      { label },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${await getToken()}`,
        },
      },
    ),

  // ── Tasks module ──────────────────────────────────────────────────────────
  getTasksForCase: async (caseId) =>
    taskAxios.get(`cases/${caseId}/tasks`, {
      headers: { "Content-Type": "application/json" },
    }),
  createTask: async (payload) =>
    taskAxios.post(`tasks`, payload, {
      headers: { "Content-Type": "application/json" },
    }),
  patchTask: async (taskId, payload) =>
    taskAxios.patch(`tasks/${taskId}`, payload, {
      headers: { "Content-Type": "application/json" },
    }),

  // Targets
  getTargets: async (taskId) =>
    taskAxios.get(`tasks/${taskId}/targets`, {
      headers: { "Content-Type": "application/json" },
    }),
  batchAddTargets: async (taskId, payload) =>
    taskAxios.post(`tasks/${taskId}/targets/batch`, payload, {
      headers: { "Content-Type": "application/json" },
    }),
  patchTarget: async (taskId, targetId, payload) =>
    taskAxios.patch(`tasks/${taskId}/targets/${targetId}`, payload, {
      headers: { "Content-Type": "application/json" },
    }),
  makeTargetPrimary: async (taskId, targetId, payload = {}) =>
    taskAxios.post(
      `tasks/${taskId}/targets/${targetId}/make-primary`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      },
    ),

  // Key Updates
  getKeyUpdates: async (taskId) =>
    taskAxios.get(`tasks/${taskId}/updates`, {
      headers: { "Content-Type": "application/json" },
    }),
  createKeyUpdate: async (taskId, payload) =>
    taskAxios.post(`tasks/${taskId}/updates`, payload, {
      headers: { "Content-Type": "application/json" },
    }),
  deleteKeyUpdate: async (taskId, sk) =>
    taskAxios.delete(`tasks/${taskId}/updates`, {
      params: { sk },
      headers: { "Content-Type": "application/json" },
    }),
};
